import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminCompanyManagement';
import DialogProductExhibition from '../../../pages/Admin/CompanyManagement/DialogProductExhibition';
import withAuth from '../../../common/WithAuth';
import AdminCompanyManagementSelector from '../../../selectors/AdminCompanyManagement';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    productData: state.adminCompanyManagement.detailProduct.data,
    editErrors: state.adminCompanyManagement.editProduct.errors,
    eventInfo: state.eventManagement.infoEvent.data,
    settingsDisplayInfo: AdminCompanyManagementSelector.createSettingDisplayInfoProductSelector()(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchGetDetailProduct: (params) => dispatch(Action.GetDetailProductExhibitionRequested(params)),
    fetchClearGetDetailProduct: () => dispatch(Action.ClearGetDetailProductExhibition()),
    fetchEditProduct: (params) => dispatch(Action.EditProductExhibitionRequested(params)),
    fetchClearEditProduct: () => dispatch(Action.ClearEditProductExhibition()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DialogProductExhibition);
